import { useQuery } from 'react-query';

import * as Api from '../api';
import * as Constants from '../constants';
import * as Mappers from '../mappers';

const useDedicatedEmployer = () => {
  const initialData = { item: Mappers.DedicatedEmployer() };

  const { data = initialData, ...args } = useQuery(
    [Constants.ENTITY, 'dedicated-employer'],
    async () => {
      const { data } = await Api.DedicatedEmployer();

      return {
        item: Mappers.DedicatedEmployer(data && data.data)
      };
    },
    { initialData }
  );

  return { ...args, ...data };
};

export default useDedicatedEmployer;
